import service from "@/axios/axiosInstance";

export const getAllDatas = async () => {
    try {
        const response = await service.get("getAllDatas.php");
        // console.log(response);
        return response;
    }catch (e) {
        console.error(e);
    }
}

export const getRankData = async () => {
    try {
        const response = await service.get("getRank.php");
        // console.log(response);
        return response;
    }catch (e) {
        console.error(e);
    }
}

export const voteForBeast = async (voteID) => {
    try {
        const response = await service.post("vote.php",{data:voteID});
        // console.log(response);
        return response;
    }catch (e) {
        console.error(e);
    }
}